export const APPOINTMENT_STATUS = [
  {
    _id: 'cancelled',
    label: 'Cancelled',
  },
  {
    _id: 'cancelled-noshow',
    label: 'No show',
  },
  {
    _id: 'confirmed',
    label: 'Confirmed',
  },
  {
    _id: 'confirmed-arrived',
    label: 'Arrived',
  },
  {
    _id: 'unconfirmed',
    label: 'Unconfirmed',
  },
];
